import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdmin } from '../../contexts/AdminContext';
import { Spinner, Container } from 'react-bootstrap';

interface BlockAttorneyProps {
  children: React.ReactNode;
}

/**
 * Route guard that blocks Attorney users from accessing certain pages.
 * Redirects attorneys to their portal.
 */
const BlockAttorney: React.FC<BlockAttorneyProps> = ({ children }) => {
  const { isAttorney, isLoading } = useAdmin();

  if (isLoading) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3 text-muted">Loading...</p>
      </Container>
    );
  }

  // If user is an attorney, redirect to attorney portal
  if (isAttorney) {
    return <Navigate to="/attorney" replace />;
  }

  // Non-attorneys can access
  return <>{children}</>;
};

export default BlockAttorney;

